import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './navigation';

export const SU_TEST_APP_TEST_ID = 'seller-university-test';

const TestApp = () => {
  return (
    <div data-testid={SU_TEST_APP_TEST_ID}>
      <Header />
      <div className="m-auto max-w-screen-lg p-su-page-padding">
        <Outlet />
      </div>
    </div>
  );
};

export default TestApp;
